/**
 * Represent the Preview Reference of an Asset.
 * @note Currently Implemented only by Audios
 * @class
 */
class PreviewReference {
    constructor() {
        this.creationState = null;
        this.creationTime = null;
        this.id = null;
        this.isTooLoud = false;
        this.name = null;
        this.originalStream = null;
        this.volumeRatio = null;
    }
}
const keysOfPreviewReference = ["creationState", "creationTime", "id", "isTooLoud", "name", "originalStream", "volumeRatio"];

export { PreviewReference, keysOfPreviewReference };
